import { Controller } from "@hotwired/stimulus"
import { requestExport } from "../helpers/request_export"

// For links to async (ExportRequest) CSV endpoints.
export default class extends Controller {
  request(event) {
    event.preventDefault()
    requestExport(this.element.href)
  }
}
